import React from "react";
import { Box } from "@mui/material";

import {
  PXDX,
  DEMOGRAPHICS,
  FREQUENCY,
  INCOMPATIBILITY,
  PRIMARY_REQUIRED,
  PLACE_OF_SERVICE,
  PRIOR_AUTH,
  UNENFORCEABLE,
  tabOrder,
  RULE_OVERRIDES,
} from "../Constants/PolicyTranslationConstants";
import RuleGrid from "../PolicyTabComponents/RuleGrid";

/**
 * PolicyTabsComponent
 * Shared between PolicyTranslation and UseCases
 */
const PolicyTabsComponent = ({
  tabValue,
  onEditNoteClick,
  handleAddNewRule,
  editable,
  policyData,
  healthPlanId,
  rules,
  setRules,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {tabValue === tabOrder.get(PXDX) && (
        <RuleGrid
          columnsToShow={{
            ruleName: true,
            cc: true,
            version: true,
            procedures: true,
            ruleType: true,
            diagnoses: true,
            modifiers: true,
            dateLOB: true,
            rationale: true,
            actions: { editNote: true, link: true },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(DEMOGRAPHICS) && (
        <RuleGrid
          columnsToShow={{
            ruleName: true,
            cc: true,
            version: true,
            procedures: true,
            ruleType: true,
            diagnoses: true,
            modifiers: true,
            dateLOB: true,
            rationale: true,
            actions: { editNote: true, link: true },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(FREQUENCY) && (
        <RuleGrid
          columnsToShow={{
            ruleName: true,
            cc: true,
            procedures: true,
            version: true,
            ruleType: true,
            diagnoses: true,
            modifiers: true,
            dateLOB: true,
            rationale: true,
            actions: { editNote: true, link: true },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(INCOMPATIBILITY) && (
        <RuleGrid
          columnsToShow={{
            ruleName: true,
            cc: true,
            procedures: true,
            version: true,
            ruleType: true,
            diagnoses: true,
            modifiers: true,
            dateLOB: true,
            rationale: true,
            actions: { editNote: true, link: true },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(PRIMARY_REQUIRED) && (
        <RuleGrid
          columnsToShow={{
            ruleName: true,
            version: true,
            cc: true,
            procedures: true,
            ruleType: true,
            diagnoses: true,
            modifiers: true,
            dateLOB: true,
            rationale: true,
            actions: { editNote: true, link: true },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(PLACE_OF_SERVICE) && (
        <RuleGrid
          columnsToShow={{
            ruleName: true,
            cc: true,
            procedures: true,
            version: true,
            ruleType: true,
            diagnoses: true,
            modifiers: true,
            dateLOB: true,
            rationale: true,
            actions: { editNote: true, link: true },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(PRIOR_AUTH) && (
        <RuleGrid
          columnsToShow={{
            ruleName: false,
            cc: true,
            procedures: true,
            ruleType: false,
            diagnoses: false,
            modifiers: false,
            dateLOB: true,
            rationale: true,
            version: true,
            actions: { editNote: true, link: false },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(UNENFORCEABLE) && (
        <RuleGrid
          columnsToShow={{
            ruleName: false,
            cc: true,
            version: true,
            procedures: true,
            ruleType: false,
            diagnoses: false,
            modifiers: false,
            dateLOB: false,
            rationale: true,
            actions: { editNote: true, link: false },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
      {tabValue === tabOrder.get(RULE_OVERRIDES) && (
        <RuleGrid
          columnsToShow={{
            version: true,
            ruleName: false,
            cc: true,
            procedures: true,
            ruleType: false,
            diagnoses: false,
            modifiers: false,
            dateLOB: false,
            rationale: true,
            actions: { editNote: true, link: false },
          }}
          onEditNoteClick={onEditNoteClick}
          handleAddNewRule={handleAddNewRule}
          editable={editable}
          policyData={policyData}
          healthPlanId={healthPlanId}
          tabValue={tabValue}
          rules={rules}
          setRules={setRules}
        />
      )}
    </Box>
  );
};

export default PolicyTabsComponent;
